import { render, staticRenderFns } from "./DashBox.vue?vue&type=template&id=f6719b4e&"
import script from "./DashBox.vue?vue&type=script&lang=js&"
export * from "./DashBox.vue?vue&type=script&lang=js&"
import style0 from "./DashBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6719b4e')) {
      api.createRecord('f6719b4e', component.options)
    } else {
      api.reload('f6719b4e', component.options)
    }
    module.hot.accept("./DashBox.vue?vue&type=template&id=f6719b4e&", function () {
      api.rerender('f6719b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DashBox.vue"
export default component.exports